import type { DynamicFilterGroup } from './types';

const PARAM = 'filters';

export function encodeFilters(filters: DynamicFilterGroup | undefined): string {
  const json = JSON.stringify(filters ?? { logic: 'AND', conditions: [] });
  const bytes = new TextEncoder().encode(json);
  let binary = '';
  bytes.forEach((byte) => { binary += String.fromCharCode(byte); });
  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '');
}

export function decodeFilters(value: string | null): DynamicFilterGroup {
  if (!value) return emptyFilters();
  try {
    const padded = value.replace(/-/g, '+').replace(/_/g, '/').padEnd(Math.ceil(value.length / 4) * 4, '=');
    const binary = atob(padded);
    const bytes = Uint8Array.from(binary, (char) => char.charCodeAt(0));
    const decoded = JSON.parse(new TextDecoder().decode(bytes));
    if (decoded?.logic !== 'AND' || !Array.isArray(decoded.conditions)) return emptyFilters();
    return { logic: 'AND', conditions: decoded.conditions };
  } catch {
    return emptyFilters();
  }
}

export function writeFiltersToSearchParams(params: URLSearchParams, filters: DynamicFilterGroup): URLSearchParams {
  const next = new URLSearchParams(params);
  if (!filters.conditions.length) next.delete(PARAM);
  else next.set(PARAM, encodeFilters(filters));
  return next;
}

export function emptyFilters(): DynamicFilterGroup {
  return { logic: 'AND', conditions: [] };
}
